import dayjsTZ from "../../../../utils/dayjs";
import { getTranslation } from "../../generate/translations";

/**
 * Build the employeesList report rows.
 * Status (Aktiv / inactive / …) is applied by the employees API at fetch time —
 * do not re-filter the full tenant dump here.
 */
export const employeesList = (data, filter, columns, manualColumns) => {
  const result = {
    columnsDef: [],
    allColumns: [],
    rowData: [],
    selectedColumns: [],
  };
  if (!data || !filter || !columns) return result;

  result.selectedColumns = manualColumns || columns.columnDefs;
  result.allColumns = columns.allAppliedColumnDefs;

  const processedData = (data || []).map((item) => ({
    ...item,
    employeeDayOfBirth: item?.employeeDayOfBirth
      ? dayjsTZ(item.employeeDayOfBirth).format("DD/MM/YYYY")
      : item?.employeeDayOfBirth,
    employeeHireDate: item?.employeeHireDate
      ? dayjsTZ(item.employeeHireDate).format("DD/MM/YYYY")
      : item?.employeeHireDate,
  }));

  const keys = Array.isArray(manualColumns)
    ? manualColumns
    : columns?.columnDefs || [];

  keys.forEach((e) => {
    result.columnsDef.push(getTranslation(e));
  });
  processedData.forEach((emplRecord) => {
    result.rowData.push(keys.map((c) => emplRecord[c]));
  });

  return result;
};
